export const filters: Readonly<Record<string, string>> = {
  analystCount: 'analyst_count',
  beta: 'beta',
  currentDividend: 'current_dividend',
  currentRoa: 'current_ROA',
  currentRoe: 'current_ROE',
  debtEquity: 'debt_equity',
  eps: 'EPS',
  futureOneYearGrowth: 'future_one_year_growth',
  futureThreeYearGrowth: 'future_three_year_growth',
  futureThreeYearRoe: 'future_three_year_ROE',
  gridVisibleFlag: 'grid_visible_flag',
  currencyDifferentFromExchange: 'currency_different_from_exchange',
  insiderBuying: 'insider_buying',
  intrinsicDiscount: 'intrinsic_discount',
  isEpsLessThanZero: 'is_eps_less_than_zero',
  isFund: 'is_fund',
  marketcap: 'market_cap',
  pastFiveYearGrowth: 'past_five_year_growth',
  pastOneYearGrowth: 'past_one_year_growth',
  pb: 'PB',
  pe: 'PE',
  peg: 'PEG',
  primaryFlag: 'primary_flag',
  sharePrice: 'share_price',
  warningType: 'warning_type',
  upcomingDividend: 'upcoming_div',
  marketCapMovement7d: 'market_cap_movement_7d',
};

export enum filterLabels {
  /** company */
  market_cap = 'Market Cap',
  share_price = 'Share Price',
  beta = '5 year Beta',
  /** valuation */
  intrinsic_discount = 'Value',
  PE = 'PE Ratio',
  PEG = 'PEG Ratio',
  PB = 'PB Ratio',
  /** future */
  future_one_year_growth = '1 Year Earnings Growth Estimate',
  future_three_year_growth = '3 Year Earnings Growth Estimate',
  future_three_year_ROE = '3 Year ROE Estimate',
  /** past performance */
  past_five_year_growth = 'Past 5 Year Earnings Growth',
  past_one_year_growth = 'Past 1 Year Earnings Growth',
  current_ROE = 'ROE Ratio',
  current_ROA = 'ROA Ratio',
  EPS = 'EPS',
  /** financial heatlh */
  debt_equity = 'Debt to Equity Ratio',
  /** dividends */
  current_dividend = 'Dividend Yield',
  upcoming_div = 'Upcoming dividend',
  /** management */
  insider_buying = 'Insider Buying Ratio',
  /** other */
  analyst_count = 'Hide companies with low analyst coverage',
  is_fund = "Include ETF's & Funds",
  primary_flag = 'Hide secondary listings',
  warning_type = 'Only show companies with recent price volatility',
  currency_different_from_exchange = 'Show companies with currency different to exchange',
}

export enum FilterTypes {
  market = 'market',
  industry = 'industry',
  additional = 'additional',
}

export const API_INFINITY_VALUE = 2147483647;

export enum FILTER_TYPE {
  RANGE = 'range',
  SLIDER = 'slider',
  TOGGLE = 'toggle',
}

export {
  ORDERED_INDUSTRIES,
  PRIMARY_INDUSTRIES,
  SECONDARY_INDUSTRIES,
  TERTIARY_INDUSTRIES,
  PRIMARY_IGNORED_WORDS,
  SECONDARY_IGNORED_WORDS,
  TERTIARY_IGNORED_WORDS,
  SECTORS,
} from './industries';

export interface QueryKeyword {
  label: string;
  demonym?: string;
  slug?: string;
  children?: string[];
  mainIndex?: string;
  mainExchange?: string;
}

const createDropdownOption = (value: string, label: string) => ({
  option: value,
  label,
});

export const orderByDropdownOptions = [
  createDropdownOption(filters.marketcap, filterLabels[filters.marketcap]),
  //
  createDropdownOption('total_score', 'Total Score'),
  createDropdownOption('value_score', 'Value Score'),
  createDropdownOption('future_performance_score', 'Future Score'),
  createDropdownOption('past_performance_score', 'Past Performance Score'),
  createDropdownOption('health_score', 'Health Score'),
  createDropdownOption('dividends_score', 'Dividends Score'),
  //
  createDropdownOption(
    filters.intrinsicDiscount,
    filterLabels[filters.intrinsicDiscount]
  ),
  createDropdownOption(filters.pe, filterLabels[filters.pe]),
  createDropdownOption(filters.pb, filterLabels[filters.pb]),
  createDropdownOption(filters.peg, filterLabels[filters.peg]),
  createDropdownOption(
    filters.futureOneYearGrowth,
    filterLabels[filters.futureOneYearGrowth]
  ),
  createDropdownOption(
    filters.futureThreeYearGrowth,
    filterLabels[filters.futureThreeYearGrowth]
  ),
  createDropdownOption(
    filters.futureThreeYearRoe,
    filterLabels[filters.futureThreeYearRoe]
  ),
  createDropdownOption(
    filters.pastOneYearGrowth,
    filterLabels[filters.pastOneYearGrowth]
  ),
  createDropdownOption(
    filters.pastFiveYearGrowth,
    filterLabels[filters.pastFiveYearGrowth]
  ),
  createDropdownOption(filters.currentRoe, filterLabels[filters.currentRoe]),
  createDropdownOption(filters.currentRoa, filterLabels[filters.currentRoa]),
  createDropdownOption(filters.eps, filterLabels[filters.eps]),
  createDropdownOption(filters.debtEquity, filterLabels[filters.debtEquity]),
  createDropdownOption(
    filters.insiderBuying,
    filterLabels[filters.insiderBuying]
  ),
  createDropdownOption(filters.sharePrice, filterLabels[filters.sharePrice]),
  createDropdownOption(filters.beta, filterLabels[filters.beta]),
  createDropdownOption(filters.analystCount, 'Analyst Coverage'),
  createDropdownOption('name', 'Company name'),
  createDropdownOption('unique_symbol', 'Symbol'),
  createDropdownOption('market_cap_movement_7d', 'Market Movers'),
];
